var accountConstants = {
    statuses: {
        NONE: false,
        UNSUBMITTED: 'Unsubmitted',
        SUBMITTED: 'Submitted',
        APPROVED: 'Approved',
        DENIED: 'Denied'
    },
    roles: {
        NONE: 'None',
        ADMIN: 'Admin',
        CUSTOMER: 'Customer',
        DISTRIBUTOR: 'Distributor',
        OEM: 'OEM',
        SALESPERSON: 'Salesperson',
        SERVICE: 'Service'
    },
    registrationRoles: [
        'CUSTOMER',
        'DISTRIBUTOR',
        'OEM'
    ],
    loginStates: {
        LOGGED_IN: 'LOGGED_IN',
        LOGGED_OUT: 'LOGGED_OUT',
        UNVALIDATED: 'UNVALIDATED'
    },
    
    userSecurityActions:{
        CHANGE_ROLE: 'CHANGE_ROLE',
        CHANGE_ENTITY: 'CHANGE_ENTITY'
    }
}

export default accountConstants;



// WEBPACK FOOTER //
// ./web-app/constants/account-constants.js